<template>
  <div class="screenshot-modal rounded overflow-hidden text-dark bg-white flex justify-center">
    <div class="w-full h-[680px] flex flex-col justify-between items-center gap-1">
      <div class="flex justify-center items-center h-full max-w-[700px] w-full">
        <!-- Image type -->
        <img v-if="isImage(currentItem?.file_type)" class="rounded-md max-h-full" :src="currentItem?.url"
          :alt="currentItem?.name" />
        <!-- Video type -->
        <VideoPlayer v-else-if="isVideo(currentItem?.file_type)" :src="currentItem.url"
          :poster="currentItem.thumbnail_url" />
      </div>
      <div class="w-full pl-2 pb-4 flex items-center gap-1">
        <svg class="text-gray" width="16" height="16" fill="none">
          <use :xlink:href="`#img-placeholder`"></use>
        </svg>
        <span class="text-12px text-gray">
          {{ currentItem?.name }} <span class="dot"></span> File size: {{ formatSize(currentItem?.size) }}
          <!-- <span class="dot"></span>
          Dimensions:
          {{ currentItem?.dimensions.width }} by {{ currentItem?.dimensions.height }} pixels -->
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import VideoPlayer from '@/components/social-products/social-boost/parts/VideoPlayer'
export default {
  name: 'ScreenshotModal',
  components: {
    VideoPlayer,
  },
  props: {
    meta: {
      type: Object,
      default: () => ({ screenshots: [], currentIndex: 0 }),
    },
  },
  data() {
    return {
      screenshots: [],
      currentSlide: this.meta.currentIndex || 0,
    };
  },
  created() {
    this.screenshots = this.meta.screenshots || [];

    this.$Modal.instance.$on('layout:change', ({ value }) => {
      if (value === 'next') {
        this.currentSlide = (this.currentSlide + 1) % this.screenshots.length;
      } else {
        this.currentSlide = (this.currentSlide - 1 + this.screenshots.length) % this.screenshots.length;
      }
    });
  },
  computed: {
    currentItem() {
      return this.screenshots[this.currentSlide];
    },
  },
  methods: {
    isImage(type) {
      return type === 'image';
    },
    isVideo(type) {
      return type === 'video';
    },
    formatSize(size) {
      if (!size || isNaN(size)) return '0 B';
      const units = ['B', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(size) / Math.log(1024));
      const result = size / Math.pow(1024, i);
      return result.toFixed(1) + ' ' + units[i];
    }
  },
};
</script>
<style lang="scss" scoped>
.dot {
  @apply w-[4px] h-[4px] bg-bordersDark rounded-full inline-block my-[2px] mx-[8px];
}
</style>